/**
 * Created by Abner Sui on 07/08/2020.
 * Description:
 *
 * ------ maintenance history ------
 * 12/27/2022 Simon Zhao default to preview files instead of downloading.
 * Updated by Daniel Wang on 4/3/2023, to handle the file fields which are not started.
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FileInfo } from '../../../tamalelibs/models/workflow.model';
import { FileHelperService } from '../../../services/file-helper.service';
import { UtilsService } from '../../../tamalelibs/services/utils.service';
import { MAX_PREVIEW_FILE_SIZE } from '../../../tamalelibs/constants/business.constants';
import { AlertBtnTypes, AlertButton } from '../../../widgets/alert-window/alert-window.model';
import { StringLiteralsPipe } from '../../../pipes/translate.pipe';
import { AlertWindowService } from '../../../widgets/alert-window/alert-window.service';
import { WorkflowService } from '../../../tamalelibs/services/workflow.service';

@Component({
    selector: 'tam-file-info-aggrid',
    templateUrl: './file-info-aggrid.component.html',
    styleUrls: ['./file-info-aggrid.component.scss']
})
export class FileInfoAggridComponent implements ICellRendererAngularComp {

    value: Array<FileInfo>;
    isNotStartTaskField = false; // used to judge whether is a start task field or not

    constructor(
        private _fileHelper: FileHelperService,
        private _alertWindow: AlertWindowService,
        private _workflowService: WorkflowService
    ) { }

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        if (params.value && params.value.length > 0) {
            this.value = params.value;
        } else {
            const fieldDefinitionId = params['fieldDefinitionId'];
            const taskDefinitionId = params['taskDefinitionId'];
            this.isNotStartTaskField = this._workflowService.isNotStartTaskFieldForInputTask(fieldDefinitionId, taskDefinitionId, params.data);
        }
    }

    onClick(event, item: FileInfo): void {
        UtilsService.stopPropagation(event);
        const fileUrl = '/restapi/2.0/workflow/task/' + item.taskId + '/filedata/' + item.id;
        if (this._fileHelper.isFilePreviewable(item)) {
            if (item.fileSize > MAX_PREVIEW_FILE_SIZE) {
                const downloadBtn: AlertButton = {
                    text: StringLiteralsPipe.translate('general.download'),
                    type: AlertBtnTypes.primary
                };
                const cancelBtn: AlertButton = {
                    text: StringLiteralsPipe.translate('general.ok'),
                    type: AlertBtnTypes.tertiary
                };
                const subscription = this._alertWindow.custom('Warning', [StringLiteralsPipe.translate('general.can_not_preview_due_to_file_size')], cancelBtn, downloadBtn)
                    .subscribe((result: boolean) => {
                        if (result) {
                            this._fileHelper.downloadFile(fileUrl);
                        }
                        subscription.unsubscribe();
                    });
            } else {
                this._fileHelper.previewFile(item.fileId, fileUrl, item.extension.replace('.', ''), item.fileName, false, false, true);
            }
        } else {
            this._fileHelper.downloadFile(fileUrl);
        }
    }

}
